/**
 * @generated SignedSource<<f62911977ac3a5f5bbf1fb6cf141df82>>
 * @relayHash 1098917183dba0d1cd9eaf669734a823
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4b2aa6cf14e215d1bf5191580a5a3d8c2932ae14422833e377b1365c0855313d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiFeaturesPlansSettingsQuery } from './uiFeaturesPlansSettingsQuery.graphql';

const node: PreloadableConcreteRequest<uiFeaturesPlansSettingsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4b2aa6cf14e215d1bf5191580a5a3d8c2932ae14422833e377b1365c0855313d",
    "metadata": {},
    "name": "uiFeaturesPlansSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
